import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { FinancialShadcnComponent } from 'app/components/analytics-financial/FinancialShadcnComponent'
import { useFinancialPage } from 'app/components/analytics-financial/useFinancialPage'
import { useCheckPermission } from 'app/hooks/useCheckPermission'

// observer: reads authStore.user/permissions in render, which resolve asynchronously (TRK-6020).
const Financial = observer(function Financial() {
  const checkPermission = useCheckPermission()

  if (!checkPermission([`org:pages:analytics:revenue`, `pages:analytics`])) {
    return <Navigate to="/analytics/marketing" replace />
  }

  const props = useFinancialPage()
  return <FinancialShadcnComponent {...props} />
})

export default Financial
